/*
 * File caricati dentro la richiesta (in base64): documenti, titoli, immagini delle squadre.
 * AWS accetta al massimo 6 MB per richiesta e il base64 pesa un terzo in piu' del file: il limite
 * del file e' quindi 4 MB. Se il file non passa, l'utente deve capire che e' per la dimensione.
 */

export const MAX_FILE_CARICATO = 4 * 1024 * 1024;

const pesoInMb = (byte) => (byte / (1024 * 1024)).toFixed(1).replace('.', ',');

/** Il file supera il limite: quanto pesa e cosa fare. */
export const messaggioFileTroppoGrande = (file) =>
    `Il file pesa ${pesoInMb(file.size)} MB: il massimo è 4 MB. Riducilo (per esempio comprimendo il PDF o l'immagine) e riprova.`;

/** Il server non ha risposto al caricamento: di solito e' il file troppo grande, o la connessione. */
export const MESSAGGIO_CARICAMENTO_NON_RIUSCITO =
    'Il file non è arrivato al server. Succede se è troppo grande (massimo 4 MB) o se la connessione si è interrotta: controlla la dimensione e riprova.';
